import { Box, styled } from '@mui/material';

export const ScreenWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  &:not(:first-child) {
    margin-left: -10px;
  }
`;
